document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll('[data-scroll]');
  const header = document.querySelector(".recycle-page-header-main");

  links.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = link.getAttribute("href").substring(1);
      const target = document.getElementById(targetId);

      if (!target) return;

      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;

      let offset;
      if (header.classList.contains('is-fixed')) {
        if (isMobile) {
          const headerHeight = header.offsetHeight;
          offset = -(headerHeight + 40);
        } else {
          const headerHeight = header.offsetHeight;
          offset = -(headerHeight + 20);
        }
      } else {
        if (isMobile) {
          offset = -355;
        } else {
          offset = -400;
        }
      }

      const targetScroll = target.getBoundingClientRect().top + window.scrollY + offset;

      window.scrollTo({
        top: targetScroll,
        behavior: "smooth"
      });
    });
  });
});